import { graphql } from "@/graphql/generated/gql";

export const ScenarioModelFragmentDocument = graphql(/* GraphQL */ `
  fragment ScenarioModelFields on ScenarioModel {
    id
    workspaceId
    title
    description
    startYear
    endYear
    createdAt
    updatedAt
    referenceInventory {
      id
      title
      year
      methodologyId
      informational
    }
    trendScenario {
      ...ScenarioFields
    }
    climateProtectionScenarioList {
      ...ScenarioFields
    }
  }
`);

export const getScenarioModelListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetScenarioModelListForWorkspace($input: GetScenarioModelListForWorkspaceInput!) {
    scenarioModelListForWorkspace(getScenarioModelListForWorkspaceInput: $input) {
      ...ScenarioModelFields
    }
  }
`);

export const getScenarioModelQueryDocument = graphql(/* GraphQL */ `
  query GetScenarioModel($input: GetScenarioModelInput!) {
    scenarioModel(getScenarioModelInput: $input) {
      ...ScenarioModelFields
    }
  }
`);

export const createScenarioModelMutationDocument = graphql(/* GraphQL */ `
  mutation createScenarioModel($input: CreateScenarioModelInput!) {
    createScenarioModel(createScenarioModelInput: $input) {
      ...ScenarioModelFields
    }
  }
`);

export const updateScenarioModelMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateScenarioModel($input: UpdateScenarioModelInput!) {
    updateScenarioModel(updateScenarioModelInput: $input) {
      ...ScenarioModelFields
    }
  }
`);

export const deleteScenarioModelMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteScenarioModel($input: DeleteScenarioModelInput!) {
    deleteScenarioModel(deleteScenarioModelInput: $input) {
      # Do not request any reference fields since they will not resolve after deletion
      id
      workspaceId
      title
    }
  }
`);

export const recoverScenarioModelInventoryPersistMutationDocument = graphql(/* GraphQL */ `
  mutation RecoverScenarioModelInventoryPersist($input: RecoverScenarioModelInventoryPersistInput!) {
    recoverScenarioModelInventoryPersist(recoverScenarioModelInventoryPersistInput: $input) {
      recoveredScenarioIdList
      removedFailedJobCount
    }
  }
`);
